import React, { memo } from 'react'

import { ChargePointImport, ConnectorImport } from '../../common/redux/api/web-api'
import { isHaloImport } from '../../lib/isHalo'
import { isDawnImport } from '../../lib/isDawn'
import { isAuraImport } from '../../lib/isAura'
import { isLunaImport } from '../../lib/isLuna'
import { PhaseMode } from '../../common/enums/phaseTypes'
import useText from '../../common/hooks/useText'

interface IImportChargePointLabelProps {
    chargePoint: ChargePointImport
}

const ImportChargePointLabel = memo((props: IImportChargePointLabelProps) => {
    const text = useText()
    const onePVal = (connector: ConnectorImport) => (
        <>
            {text('msgImportInst')}:{connector.installationPhaseMode}-{connector.installationPhase}-
            {connector.installationCurrent}A, LB:
            {connector.loadBalancerOfflinePhase}-{connector.loadBalancerOfflineCurrent}A
        </>
    )

    const threePVal = (connector: ConnectorImport) => (
        <>
            {text('msgImportInst')}:{connector.installationPhaseMode}-{connector.installationCurrent} A, LB:
            {connector.loadBalancerOfflinePhase}-{connector.loadBalancerOfflineCurrent} A
        </>
    )

    const AuraInformation = () => {
        return props.chargePoint.connectors.map((connector: ConnectorImport) => ConnectorInfo(connector))
    }

    const ConnectorInfo = (connector: ConnectorImport) => {
        return (
            <div>
                {(connector.installationPhaseMode === PhaseMode.onePhase || connector.installationPhaseMode === null) &&
                    onePVal(connector)}
                {connector.installationPhaseMode === PhaseMode.threePhase && threePVal(connector)}
            </div>
        )
    }

    return (
        <div>
            {isAuraImport(props.chargePoint) && AuraInformation()}
            {(isHaloImport(props.chargePoint) || isDawnImport(props.chargePoint) || isLunaImport(props.chargePoint)) &&
                ConnectorInfo(props.chargePoint.connectors[0])}
        </div>
    )
})

export default ImportChargePointLabel
